export default "__VITE_PUBLIC_ASSET__c865ccc9__"